module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18489/js/img/valuePropModals/WhatsApp/ValueProp3.svg"